module.exports = __webpack_public_path__ + "img/builder-33.dea90d7b.jpg";